import { AdminRole } from "entities/auth/types";
import {
  BRAND_TAB_PATH,
  BRAND_SUB_PAGE_PATH,
  BULLETINS_PATH,
  FAQ_GROUP_PATH,
  FAQS_PATH,
  GAMES_PATH,
  TAGS_AND_METADATA_PATH,
  MODULES_PATH,
  ROLES_AND_PERMISSIONS,
  STUDIOS_PATH,
  TRANSLATIONS_DYNAMIC_PATH,
  TRANSLATIONS_STATIC_PATH,
  MANAGE_ARTICLES_PATH,
  MANAGE_ARTICLE_DETAILS_PATH,
  MANAGE_ARTICLES_GROUP_PATH,
  CONTENT_SCHEDULE_PATH,
} from "shared/routes/paths";
import { areRoutesEqual } from "shared/routes/utils";
import { permissionsMap } from "../constants";
import { Action, Area } from "../useRolePermission/types";

// can be used to check if a user has any of the permissions in area for action
export const isActionAllowedInArea = (
  area: Area,
  action: Action,
  currentRoles: AdminRole[],
) => {
  return Boolean(
    Object.entries(permissionsMap).find(([key, roles]) => {
      const permissionArea = key.split(":")[0];
      const permissionAction = key.split(":").pop();

      if (permissionArea !== area || permissionAction !== action) {
        return false;
      }

      return roles.some((role) => currentRoles.includes(role));
    }),
  );
};

export const isLocationAllowed = (
  pathname: string,
  roles: AdminRole[],
): boolean => {
  if (
    areRoutesEqual(pathname, BRAND_TAB_PATH) ||
    areRoutesEqual(pathname, BRAND_SUB_PAGE_PATH)
  ) {
    return isActionAllowedInArea("brandsAndPages", "read", roles);
  }

  if (
    areRoutesEqual(pathname, MANAGE_ARTICLES_PATH) ||
    areRoutesEqual(pathname, MANAGE_ARTICLES_GROUP_PATH) ||
    areRoutesEqual(pathname, MANAGE_ARTICLE_DETAILS_PATH)
  ) {
    return isActionAllowedInArea("legalDocuments", "read", roles);
  }

  if (
    areRoutesEqual(pathname, FAQ_GROUP_PATH) ||
    areRoutesEqual(pathname, FAQS_PATH)
  ) {
    return isActionAllowedInArea("faq", "read", roles);
  }

  if (
    [TRANSLATIONS_STATIC_PATH, TRANSLATIONS_DYNAMIC_PATH].includes(pathname)
  ) {
    return isActionAllowedInArea("translations", "read", roles);
  }

  switch (pathname) {
    case TAGS_AND_METADATA_PATH:
      return isActionAllowedInArea("tags", "read", roles);
    case STUDIOS_PATH:
      return isActionAllowedInArea("studios", "read", roles);
    case MODULES_PATH:
      return isActionAllowedInArea("moduleTemplates", "read", roles);
    case CONTENT_SCHEDULE_PATH:
      return isActionAllowedInArea("contentSchedule", "read", roles);
    case GAMES_PATH:
      return isActionAllowedInArea("games", "read", roles);
    case BULLETINS_PATH:
      return isActionAllowedInArea("bulletinBoard", "read", roles);
    case ROLES_AND_PERMISSIONS:
      return isActionAllowedInArea("rolesAndPermissions", "read", roles);
    default:
      return true;
  }
};
